import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import {
  attachmentModule,
  preview,
  viewControlInTreatment,
  wasmModule,
} from "@/gluelayer"
import { Box, Button, Grid, Tooltip, Typography } from "@mui/material"
import { useEffect } from "react"
import { singleData } from "@/UDTreat/UDesign/Attachments/columns"
import AttachmentWarning from "@/UDTreat/UDesign/Attachments/AttachmentWarning"
import { updateClinicalSettings } from "@/core/app/slices/user/userApis"

const { drawAuxullarties } = viewControlInTreatment

export const AttachmentList = ({
  showSave = false,
}: {
  showSave?: boolean
}) => {
  const { attachInit } = useAppSelector((state: RootState) => state.userService)
  const {
    clinicalSettings: { DefineAttachment },
  } = useAppSelector((state: RootState) => state.userService)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!attachInit) return
    attachmentModule.setAttachmentSelectAbleType("NormalAttachment")
    attachmentModule.SetAddAllAttachmentSettingData(
      JSON.stringify(DefineAttachment),
    )
    setTimeout(() => {
      const auxTmp = [{ type: "Normal", elements: [] }] as any
      singleData.subData.map((item) => {
        item.data.map((i) => {
          const ele = document.getElementById(`${i.name}${i.key}`)
          auxTmp[0].elements.push([i.id, ele])
        })
      })

      const canvasRoot = document.getElementById("scrollWrap")
      drawAuxullarties(canvasRoot, auxTmp)
    }, 10)
  }, [attachInit])

  const onSelectAux = (id: number) => {
    attachmentModule.setAttachmentSelectLibID(id)
  }

  const AuxWindow = (name: string, AuxDatas, key: string | number) => {
    return (
      <Grid container item xs={12} key={key}>
        <Grid item xs={12}>
          <Typography variant="h6"> {name} </Typography>
        </Grid>
        {AuxDatas.map((auxData) => {
          return (
            <Grid item xs={3} key={auxData.key}>
              <Tooltip title={auxData.name}>
                <Box
                  sx={{
                    width: "64px",
                    height: "64px",
                    border: 1,
                    cursor: "pointer",
                  }}
                  id={`${auxData.name}${auxData.key}`}
                  onClick={() => {
                    onSelectAux(+auxData.id)
                  }}
                />
              </Tooltip>
            </Grid>
          )
        })}
      </Grid>
    )
  }

  return (
    <>
      <Box
        id="scrollWrap"
        sx={{
          width: "320px",
          position: "relative",
          backgroundColor: "#FAFAFA",
          paddingLeft: 1,
          paddingBottom: 1,
        }}
      >
        <Grid container alignItems={"center"} spacing={0.25}>
          {singleData.subData.map((subdata) => {
            return AuxWindow(subdata.name, subdata.data, subdata.name)
          })}
        </Grid>

        {showSave && (
          <Button
            sx={{ mt: 2, backgroundColor: "#42A5F5" }}
            variant="contained"
            onClick={() => {
              const settingJson =
                attachmentModule.GetSingleAttachmentSettingJson()
              dispatch(
                updateClinicalSettings({
                  DefineAttachment: JSON.parse(settingJson),
                }),
              ).catch((err) => {
                alert(" Failed to save settings: " + err.message)
              })
            }}
          >
            Save
          </Button>
        )}
      </Box>
      <AttachmentWarning switchViewEdit={attachInit} />
    </>
  )
}
